@if (canShowStepNavigation && directionListResponse()?.path?.length > 0) {
  <div class="step-by-step-toolbar">
    @for (area of directionListResponse() | pathInstruction; track area; let idx = $index) {
      @if (area.areaId === areaId() && groupIdx() === idx) {
        <div class="scrolling-effect">
          <div class="step-by-step-toolbar-inner">
            @for (direction of area.instructions; track direction; let i = $index) {
              <assist-directions-item-renew
                [selected]="selectedDirectionItemIdx() === i"
                [lastStepShouldBeRestart]="true"
                (buttonClicked)="directionItemSelected(direction, i)"
                (toNextArea)="moveToNextArea()"
                [direction]="direction"
                [routeNoteNumber]="routeNoteNumber(idx, i)"
              />
            }
          </div>
        </div>
      }
    }
  </div>
}

<div class="navigation-toolbar" data-cy="kiosk-nav-toolbar">
  <div class="navigation-toolbar-inner">
    <div class="navigation-toolbar-info">
      <div class="navigation-to" data-cy="navigation-mobile-target" (click)="openTargetDetail()">
        <cue-icon [icon]="ICONS.cueNavigationCircle" theme="neutral" class="icon" />
        <span class="navigation-to-text">
          <span class="static-text">{{ translation.navigation.navigationTo | transloco }}</span>
          {{ navBarData().targetName | localizedString }}
        </span>
      </div>
      <div class="navigation-toolbar-info-bottom">
        @if (isBarrierFreeRoute()) {
          <span class="barrier-path-info" data-cy="barrier-free-button">
            <cue-icon [icon]="ICONS.cueWheelchair" />
          </span>
        }

        <button cue-button size="small" class="link" (click)="closeRoute.emit()">
          {{ translation.navigation.closeRoute | transloco }}<cue-icon [icon]="ICONS.cueClose" />
        </button>
      </div>
    </div>
    <assist-navigation-route-overview
      [areaId]="areaId()"
      [groupIdx]="groupIdx()"
      [navBarData]="navBarData()"
      [routeOverviewNotes]="routeOverviewNotes()"
      (requestMoveToSpecificArea)="requestMoveToSpecificArea.emit($event)"
    />
  </div>
</div>
